<template>
    <div class="Header">
        <div class="nav">
            <div @click="homeLink()"><img src="../assets/publicImg/logoOne.png"></div>
            <div v-text="$t(title)"></div>
            <div><img src="../assets/publicImg/headerIcon.png" v-on:click="showControlContainer()"></div>
        </div>
        <div class="controlContainer_bg" v-if="isShowControlContainer" @click="Disappear()"></div>
        <div class="controlContainer" v-if="isShowControlContainer">
            <ul class="please-Login-container">
                <li>
                    <img :src="userInformationObj.head_pic? userInformationObj.head_pic.replace('/public',weburl+'/public'):this.photoImg">
                </li>
                <li>
                    <span @click="checkLogin()" v-text="$t(loginName)"></span>
                </li>
                <li>
                    <img src="../assets/publicImg/please_login_btn_icon.png" alt="" @click="logout()" v-if="isLogin">
                </li>
            </ul>
            <div class="cate-btn-container">
                <div class="cate-btn-container-son" v-for="(n,i) in cateName" :key="i">
                    <span v-bind:class="{ selectedFontColor:current===i }" @click="clickCate(i)">{{$t(n)}}</span>
                    <div class="slide-bottom-item" v-bind:class="{ selectedBgColor:current === i }"></div>
                </div>
            </div>
            <div class="buyCar-container" @click="goToBuyCar()">
                <img src="../assets/publicImg/buyCar_btn_icon.png"><span>{{$t('cart')}}</span>
            </div>
               <div class="lang-container">
                   <span v-bind:class="{'selectedLangFontColor':lang === '0' }" @click="changeLangEvent('0' ,'zh')">{{$t('language.Chinese')}}</span>
                   <span
                       class="vertical-bar">|</span><span v-bind:class="{ 'selectedLangFontColor':lang === '1' }" @click="changeLangEvent('1','en')">{{$t('language.English')}}</span><span
                       class="vertical-bar">|</span><span v-bind:class="{ 'selectedLangFontColor':lang === '2' }" @click="changeLangEvent('2','kor')">{{$t('language.korea')}}</span><span
                       class="vertical-bar">|</span><span v-bind:class="{ 'selectedLangFontColor':lang === '3' }" @click="changeLangEvent('3','jap')">{{$t('language.Japanese')}}</span>
               </div>
            <div class="search-container">
                <div class="search-container-son">
                    <form @submit.prevent action="#">
                        <img src="../assets/publicImg/find_btn_icon.png" class="find-btn-icon">
                        <input type="search" :placeholder="$t('placeholder_c')" v-model="words" @blur="searchIos"
                               @keypress="searchAndroid"  x-webkit-speech lang="zh-CN" x-webkit-grammar="builtin:search">
                        <img src="../assets/publicImg/cancel_btn_icon.png" class="cancel-btn-icon"
                             @click="deleteContent()">
                        <img src="../assets/publicImg/trum_btn_icon.png" class="trum-btn-icon"
                             @touchstart.prevent="handleTouchStart" @touchend="handleTouchEnd">
                    </form>

                </div>
            </div>
            <div class="discern" v-if="isDiscern">识别中…</div>
        </div>
    </div>
</template>

<script>
    import wx from 'weixin-js-sdk';
    import {Toast} from 'mint-ui';
    import photo from '../assets/images/personalCenter/photo.png';
    // import '../../public/static/js/luyin'

    export default {
        name: "Header",
        data: function () {
            return {
                isShowControlContainer: false,
                cateName: ['nav.index', "nav.theme", "nav.restaurant", "nav.activity", "nav.performance", "nav.service", "nav.online"],
                selectedItemIndex: '0',
                lang: localStorage.getItem('langColor') || '0' ,
                userInformationObj: {},
                loginName: 'please_login',
                isLogin: false,
                words: '',
                photoImg: photo,
                isLayout: false,
                localId: '',
                isDiscern: false,
                recorder: '',
                langTypes:['language.Chinese','language.English','language.korea','language.Japanese'],
            }
        },
        inject: ['reload'],
        created() {
            // 所有需要使用JS-SDK的页面必须先注入配置信息，否则将无法调用
            let curl = location.href;
            // console.log(curl);
            if(curl.indexOf("?")>=0){
                var rurl = location.href.split('?')[0];
                // console.log(rurl);
            }else{
                var rurl = location.href.split('#')[0];
                // console.log(rurl);
            }
            this.$http({
                method: "post",
                url: this.weburl + 'Home/WeixinJs/getWxSignPackage',
                dataType: "json",
                data: {
                    rurl:rurl
                }
            })
            .then((res) => {
                console.log(res)
                if (res.data.status === 1) {
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: res.data.result.appId, // 必填，公众号的唯一标识
                        timestamp: res.data.result.timestamp, // 必填，生成签名的时间戳，精确到秒
                        nonceStr: res.data.result.nonceStr, // 必填，生成签名的随机串
                        signature: res.data.result.signature, // 必填，签名
                        jsApiList: ['startRecord', 'stopRecord','onVoiceRecordEnd','translateVoice'],// 必填，需要使用的JS接口列表
                    })
                    // config信息验证后才执行
                    wx.ready(() => {
                        if (!localStorage.prevTime || new Date().getTime() > localStorage.prevTime) {
                            wx.startRecord({
                                success: function() {
                                    var days=1000*60*60*24*3;
                                    localStorage.prevTime = new Date().getTime() + days;
                                    // 仅仅为了授权，所以立刻停掉
                                    wx.stopRecord();
                                },
                                cancel: function() {
                                    alert('用户拒绝授权录音');
                                }
                            });
                        }
                    })
                    // 微信sdk错误返回问题
                    wx.error((res) => {
                        // alert('出错了：' + res.errMsg)// 这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
                    })
                }else{
                        // setTimeout(() => {
                        //     this.$router.push({ path: '/market'});
                        // }, 1500);
                }
            })
            .catch((error) => {
                console.log(error)
            })
        },
        methods: {
            goToBuyCar: function () {
                this.$router.push({path: '/buyCar'});
                this.isShowControlContainer = false;
            },
            clickCate: function (i) {
                this.selectedItemIndex = i;
                this.$store.commit("set_current", this.selectedItemIndex);
                switch (i) {
                    case 0:
                        this.$router.push({path: '/'});
                        this.isShowControlContainer = false;
                        break;
                    case 1:
                        this.$router.push({path: '/themeScream'});
                        this.isShowControlContainer = false;
                        this.$store.commit("set_park_index", 0);
                        break;
                    case 2:
                        this.$router.push({path: '/repast'});
                        this.isShowControlContainer = false;
                        break;
                    case 3:
                        this.$router.push({path: '/activity'});
                        this.isShowControlContainer = false;
                        break;
                    case 4:
                        this.$router.push({path: '/performance'});
                        this.isShowControlContainer = false;
                        break;
                    case 5:
                        this.$router.push({path: '/traffic'});
                        this.isShowControlContainer = false;
                        // localStorage.removeItem('moveObj');
                        break;
                    case 6:
                        this.$router.push({path: '/market/?dex=0'});
                        // window.location.href = 'http://oauthpyr.wx.xiao-bo.com/zZ48BFD164.aspx?site_id=zz-open-jmeii.wxa173a7392f915647&word=mall_ticket_b%24group_id%3aabc-33fe1e04-3107-4f07-b672-64bb3fe16009&code=FAN.23359969.6365560482393656338061%60';
                        this.isShowControlContainer = false;
                        break;
                }
            },
            Disappear() {
                this.isShowControlContainer = false;
            },
            showControlContainer: function () {
                this.checkLoginAgain();
                var user = JSON.parse(localStorage.getItem("userInfo"));
                if (!user) {
                    this.userInformationObj = {
                        head_pic: '',
                        nickname: '',
                        mobile: ''
                    };
                    this.isLogin = false;
                } else {
                    this.isLogin = true;
                    this.userInformationObj = user;
                    if (this.userInformationObj.nickname === '' || this.userInformationObj.nickname === undefined || this.userInformationObj.nickname == null) {
                        this.loginName = this.userInformationObj.mobile;

                    } else {
                        this.loginName = this.userInformationObj.nickname;
                    }
                }
                this.isShowControlContainer = !this.isShowControlContainer;
            },
            search() {
                this.$router.push({
                    path: `/search`,
                    query: {
                        keywords: this.words
                    }
                });
                this.isShowControlContainer = false;
                this.selectedItemIndex = '-1';
                this.$store.commit("set_current", '-1');
            },
            searchIos() {
                //ios点击完成失去焦点搜索
                this.search();
            },
            searchAndroid(event) {
                //android点击搜索，未能失去焦点，故失去焦点事件无法触发，单可以调用键盘事件处理
                if (event.keyCode === 13) { //如果按的是enter键 13是enter
                    event.preventDefault(); //禁止默认事件（默认是换行）
                    this.search();
                }
            },
            deleteContent() {
                this.words = ''
            },
            homeLink() {
                this.$router.push({path: `/`});
            },
            checkLogin() {
                //判断是否登入
                if (this.isLogin) {
                    this.$router.push({path: `/personalCenter`});
                    this.isShowControlContainer = false;
                    return false;
                }
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "Home/User/checkLogin",
                    dataType: "json",
                })
                .then(res => {
                    if (res.data.status === 1) {
                        if (res.data.result) {
                            this.loginSuccess1();
                            this.isLogin = true;
                        } else {
                            localStorage.clear();
                            this.$router.push({path: `/login`});
                            this.reload();
                            this.isShowControlContainer = false;
                            this.isLogin = false;
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                })
            },
            loginSuccess1() {
                this.userInformationObj = JSON.parse(localStorage.getItem("userInfo"));
                if (this.userInformationObj.nickname === '' || this.userInformationObj.nickname === undefined || this.userInformationObj.nickname == null) {
                    this.loginName = this.userInformationObj.mobile;
                } else {
                    this.loginName = this.userInformationObj.nickname;
                }

            },
            checkLoginAgain() {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "Home/User/checkLogin",
                    dataType: "json",
                })
                    .then(res => {
                        if (res.data.status === 1) {
                            console.log(res);
                            if (res.data.result) {
                                this.isLogin = true;
                                this.loginSuccess(res.data.result);
                            } else {
                                localStorage.clear();
                                this.isLogin = false;
                            }
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            logout() {
                //退出登入
                if (this.isLogin) {
                    this.isLogin = false;
                    this.loginName = 'please_login';
                    this.$http({
                        xhrFields: {
                            withCredentials: true
                        },
                        crossDomain: true,
                        method: "post",
                        url: this.weburl + "/Home/User/logout",
                        dataType: "json",
                    })
                    .then(res => {
                        if (res.data.status == 1) {
                            this.userInformationObj = {};
                            localStorage.clear();
                            this.$store.commit("set_userInformation", '');
                            Toast(res.data.msg);
                            this.$router.push({path: `/`});
                            this.isShowControlContainer = false;
                        } else {
                            Toast(res.data.msg);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
                }
            },
            loginSuccess(data) {
                var obj = {};
                obj.nickname = data.nickname;
                obj.mobile = data.mobile;
                obj.head_pic = data.head_pic;
                this.userInformationObj =obj;
                if (this.userInformationObj.nickname == '' || this.userInformationObj.nickname == undefined || this.userInformationObj.nickname == null) {
                    this.loginName = this.userInformationObj.mobile;
                } else {
                    this.loginName = this.userInformationObj.nickname;
                }
                //存入
                localStorage.setItem('userInfo', JSON.stringify(obj));
                this.$store.commit("set_userInformation", obj);
            },
            //语音处理
            handleTouchStart() {
                // this.startRecording();
                let that = this;
                // that.handleTouchEnd();
                that.time = 0;
                wx.startRecord({
                    success: function () {
                        that.timer = setInterval(() => {
                            that.time++
                        }, 1000)
                        wx.onVoiceRecordEnd({
                            // 录音时间超过一分钟没有停止的时候会执行 complete 回调
                            complete: function (res) {
                                // 60秒停止录音
                                that.localId = res.localId
                                clearInterval(that.timer);
                            }
                        })
                    },
                    fail: function () {
                    // 开始录音失败
                    },
                    cancel: function () {
                    // 用户拒绝授权录音
                    }
                })
            },
            handleTouchEnd() {
                // this.uploadAudio();
                let that = this
                wx.stopRecord({
                    success: function (res) {
                        if(that.time<0.5){
                            return
                        }
                        // 暂停成功
                        clearInterval(that.timer)
                        that.localId = res.localId
                        wx.translateVoice({
                            localId: that.localId,
                            complete: function (res) {
                                // 调用翻译完成时
                                that.words = res.translateResult.replace(/[\s|\~|`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g,"");
                                // console.log(res.translateResult);
                                that.searchAndroid(event);
                            }
                        });
                    },
                    fail: function (error) {
                        // 停止失败
                    }
                })
            },
            // startRecording() {
            //     this.$toast('开始录音');
            //     let  recorder = new Recorder();
            //     console.log(recorder);
            //    HZRecorder.get(function (rec) {
            //         console.log(rec);
            //        this.$toast('开始录音');
            //         this.isDiscern = true;
            //         this.recorder = rec;
            //         this.recorder.start();
            //         console.log(this.recorder)
            //     });
            // },
            // uploadAudio() {
            //     // 提交到服务器
            //     this.recorder.upload("https://www.chuanloo.com/Home/Asr/asr", function (state, e) {
            //         switch (state) {
            //             case 'uploading':
            //                 this.isDiscern = true;
            //                 //var percentComplete = Math.round(e.loaded * 100 / e.total) + '%';
            //                 break;
            //             case 'ok':
            //                 this.isDiscern = false;
            //                 // alert(e.target.responseText);
            //                 var obj = JSON.parse(e.target.responseText);
            //                 // console.log(obj);
            //                 if (obj['status'] == 1) {
            //                     console.log(obj['data']['result'][0]);
            //                     this.words = obj['data']['result'][0];
            //                     this.search();
            //                     this.stopRecording();
            //                 }
            //                 // alert("上传成功");
            //                 // console.log(e.currentTarget.response['data']);
            //                 break;
            //             case 'error':
            //                 Toast("上传失败");
            //                 break;
            //             case 'cancel':
            //                 Toast("上传被取消");
            //                 break;
            //         }
            //     });
            // },
            // stopRecording() {
            //     this.recorder.stop();
            // },
            playRecording() {
                this.recorder.play(document.querySelector('audio'));
            },
            changeLangEvent(i,type){
                this.lang = i;
                localStorage.setItem('langColor', i);
                this.$i18n.locale = type;
                localStorage.setItem('lang',type);
                window.location.reload(); //最直接的方式更改样式，刷新渲染,为了和写死的多语言数据更换，需刷新

            }
        },
        computed: {
            //计算属性，
            weburl: function () {
                return this.$store.state.weburl;
            },
            current: function () {
                //先用变量接住我们存储在vuex里面的数据，
                return this.$store.state.home.current;
            },
            userInformation: function () {
                return this.$store.state.personal.userInformation;
            },
            title() {
                return this.$store.state.home.title;
            }
        },
    }
</script>

<style scoped lang="less">
    @import '../assets/less/common.less';

    .Header {
        width: @width;
        position: fixed;
        top: 0;
        /*left: 0;*/
        z-index: 999;
        /* height: 100%;
         background: rgba(0, 0, 0, 0.3);*/
    }

    .nav {
        width: @width;
        height: 44px;
        background-image: url('../assets/publicImg/headerBgImg.png');
        display: flex;
        & div {
            line-height: 44px;
            text-align: center;
            &:nth-child(1) {
                width: 15%;
                img {
                    width: 35px;
                    margin-top: 3px;
                }
            }
            &:nth-child(2) {
                width: 70%;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                color: @font-primary;
                font-size: @font + .1;
            }
            &:nth-child(3) {
                width: 15%;
                line-height: 52px;
                img {
                    width: 20px;
                    height: 18px;
                }
            }
        }
    }

    .controlContainer_bg {
        position: fixed;
        top: 44px;
        width: @width;
        z-index: 900;
        height: 100vh;
        background: rgba(0, 0, 0, 0.3);
    }

    .controlContainer {
        background: @font-primary;
        z-index: 9999;
        position: fixed;
        width: @width;
    }

    .please-Login-container {
        height: 70px;
        background-color: @font-primary;
        border-bottom: 6px solid @bg;
        display: flex;
        & > li:nth-child(2n-1) {
            flex: 1;
            text-align: center;
        }
        & > li:nth-child(2) {
            flex: 2;
            line-height: 70px;
        }
        & li:nth-child(1) {
            .border-radius(50%);
            img {
                .border-radius(50%);
                width: 60px;
                height: 60px;
                margin-top: 5px;
                background: @bg;
            }
        }
        & li:nth-child(3) {
            img {
                width: 30px;
                margin-top: 18px
            }
        }

    }

    .cate-btn-container {
        /*margin-top: 6px; */ //修改
        width: @width;
        /*height: 100px;*/
        background-color: @font-primary;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-content: center;
    }

    .cate-btn-container-son {
        /*width: 24.3%;*/
        height: 50px;
        text-align: center;
        line-height: 40px;
        padding: 0 3%;
    }

    .cate-btn-container-son span {
        font-size: 16px;
        color: @word;
    }

    .slide-bottom-item {
        width: 28px;
        height: 4px;
        /* background-color: brown; */
        .border-radius(3px);
        margin: 0 auto;
        position: relative;
        bottom: 5px;
    }

    .selectedBgColor {
        background-color: @brick_red;
    }

    .selectedFontColor {
        color: @brick_red !important;
    }

    .buyCar-container {
        width: @width;
        height: 60px;
        border-top: 6px solid @bg;
        background-color: @font-primary;
        text-align: center;
        line-height: 60px;
    }

    .buyCar-container img {
        width: 22px;
        height: 22px;
        position: relative;
        top: 4px;
    }

    .buyCar-container span {
        color: @brick_red;
        font-size: 17px;
        position: relative;
        left: 10px;
    }

    .lang-container {
        width: 100%;
        height: 57px;
        background-color: @font-primary;
        border-top: 6px solid @bg;
        text-align: center;
        line-height: 57px;
        font-size: 17px;
        letter-spacing: 1px;
        color: @word;
    }

    .vertical-bar {
        margin-left: 15px;
        margin-right: 15px;
    }

    .selectedLangFontColor {
        color: @brick_red;
    }

    .search-container {
        width: @width;
        height: 59px;
        background-color: @font-primary;
        border-top: 6px solid @bg;
        border-bottom: 5px solid @bg;
    }

    .search-container-son {
        width: 90%;
        height: 47px;
        border: solid 1px #808081;
        .border-radius(50px);
        margin: 0 auto;
        position: relative;
        top: 5px;
        line-height: 47px;
        form {
            .img;
        }
    }

    .find-btn-icon {
        width: 22px;
        height: 22px;
        position: relative;
        left: 10px;
        top: 5px;
    }

    .search-container-son input {
        height: 30px;
        width: 69%;
        position: relative;
        left: 20px;
        bottom: 2px;
        font-size: 16px;
        letter-spacing: 1px;
        @media (min-width: 411px) {
            width: 69% ;
        }
        @media (max-width: 360px) {
            width: 66% ;
        }
        @media (max-width: 320px) {
            width: 63%;
        }
    }

    .cancel-btn-icon {
        width: 22px;
        position: relative;
        left: 6%;
        top: 5px;
        @media (min-width: 411px) {
            left: 8%;
        }
        @media (max-width: 360px) {
            left: 6%;
        }
        @media (max-width: 320px) {
            left: 8%;
        }

    }

    .trum-btn-icon {
        width: 17px;
        position: relative;
        top: 7px;
        left: 9%;
        @media (max-width: 360px) {
            left: 10%;
        }
        @media (max-width: 320px) {
            left: 10%;
            width: 15px;
        }
        @media (min-width: 411px) {
            left: 11%;
        }
    }

    .discern {
        position: fixed;
        top: 60%;
        left: 36%;
        width: 28%;
        height: 50px;
        border: 1px solid #ccc;
        text-align: center;
        line-height: 50px;
        font-size: 15px;
        background: #fff;
        .border-radius(10px)

    }

    @media (min-width: 768px) and (orientation: portrait) {
        .nav {
            height: 70px;
            & div {
                line-height: 70px;
                &:nth-child(1) {
                    img {
                        width: 56px;
                    }
                }
                &:nth-child(2) {
                    font-size: @font + .7;
                }
                &:nth-child(3) {
                    width: 15%;
                    line-height: 90px;
                    img {
                        width: 35px;
                        height: 30px
                    }
                }
            }
        }

        .controlContainer_bg {
            top: 70px;
        }

        .please-Login-container {
            height: 90px;
            & > li:nth-child(2) {
                font-size: @font + .2;
                line-height: 90px;
            }
            & li:nth-child(1) {

                img {
                    .border-radius(50%);
                    width: 80px;
                    height: 80px;
                }
            }
            & li:nth-child(3) {
                img {
                    width: 40px;
                    margin-top: 25px
                }
            }
        }

        .cate-btn-container-son {
            width: 13.3%;
            height: 60px;
            text-align: center;
            line-height: 50px;
        }

        .cate-btn-container-son span {
            font-size: @font + .2;

        }

        .slide-bottom-item {
            width: 32px;
        }

        .buyCar-container img {
            width: 35px;
            height: 35px;
            top: 10px;
        }

        .buyCar-container span {
            font-size: 18px;
        }

        .search-container {
            width: @width;
            height: 76px;
        }

        .search-container-son {
            top: 15px;
        }

        .find-btn-icon {
            width: 28px;
            height: 28px;
            left: 14px;
            top: 7px;
        }

        .search-container-son input {
            width: 80%;
        }

        .cancel-btn-icon {
            width: 26px;
            left: 39px;
            top: 8px;
        }

        .trum-btn-icon {
            width: 17px;
            left: 49px;
            top: 8px;

        }
    }

    @media screen and (max-width: 1020px) and (orientation: landscape) {
        .Header {
            width: 100vh;
        }
        .controlContainer_bg {
            width: 100vh;
        }

        .controlContainer {
            width: 100vh;
        }
    }
</style>

